import { selectXsrfToken } from 'modules/auth/selectors';
import watchProgress from 'model/watchProgress';
import * as auth from 'modules/auth';
import { fetchCreditCardUpdatableAccounts } from '../accountId';

export default async (dispatch) => {
  const xsrfToken = await watchProgress(selectXsrfToken);
  if (!xsrfToken) {
    auth.actions.goToLogin();
    return;
  }

  await dispatch(fetchCreditCardUpdatableAccounts());
};
